import type { ReactNode } from 'react';

import styles from './button.module.scss';

/**
 * Plain text goes straight into the button, as it would in a native one; anything richer is
 * wrapped so it can shrink and truncate inside the flex row.
 */
function ButtonLabel(props: { children: ReactNode }) {
    const { children } = props;
    if (typeof children === 'string' || typeof children === 'number') {
        return <>{children}</>;
    }
    return <span className={styles.label}>{children}</span>;
}

export default function ButtonContent(props: {
    icon?: ReactNode;
    iconEnd?: ReactNode;
    children?: ReactNode;
}) {
    const { icon, iconEnd, children } = props;
    const hasLabel = children !== undefined && children !== null && children !== '';

    return (
        <>
            {icon ? (
                <span className={styles.icon} aria-hidden="true">
                    {icon}
                </span>
            ) : null}
            {hasLabel ? <ButtonLabel>{children}</ButtonLabel> : null}
            {iconEnd ? (
                <span className={styles.icon} aria-hidden="true">
                    {iconEnd}
                </span>
            ) : null}
        </>
    );
}
